<template>
  <div id="app">
    <div id="pano"></div>

    <transition name="fade">
      <div class="wrap" v-if="content">
        <div class="wrap-header">
          <a
            href="javascript:;"
            class="close"
            :style="{backgroundImage:'url('+icon.close+')',zIndex:9999}"
            @click="closeContent"
          ></a>
        </div>
        <scroll-bar
          class="wrap-body"
          :scrollTrackStyle="scrollTrackStyle"
          :scrollBarStyle="scrollBarStyle"
          :watchValue="true"
        >
          <div v-html="content"></div>
        </scroll-bar>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="wrap"
        v-if="showTeamLayer"
        @click="()=>{this.showTeamLayer = false}"
        :style="{textAlign:'center'}"
      >
        <img
          :src="icon.teamImg"
          alt
          :style="{position:'absolute',display:'block',height:'auto',width:'300px',top:'0',left:'0',bottom:0,right:0,margin:'auto'}"
        />
      </div>
    </transition>
    <div id="menu" v-if="this.$root.ui">
      <ul>
        <li>
          <a href="javascript:;" @click="toggleScene">
            <span class="icon icon-scene" :style="{backgroundImage:'url('+icon.scene+')'}"></span>场景列表
          </a>
        </li>
        <li>
          <a href="javascript:;" @click="loadContent('pages/info.html')">
            <span class="icon icon-info" :style="{backgroundImage:'url('+icon.info+')'}"></span>明堂红木
          </a>
        </li>
        <li>
          <a href="javascript:;" @click="loadContent('pages/card.html')">
            <span class="icon icon-card" :style="{backgroundImage:'url('+icon.card+')'}"></span>联系我们
          </a>
        </li>
        <li>
          <a href="javascript:;" @click="toggleMore">
            <span class="icon icon-more" :style="{backgroundImage:'url('+icon.more+')'}"></span>更多功能
          </a>
          <ul class="more" :class="{'show-more': showMore}">
            <li>
              <a href="javascript:;" @click="toggleBGN">
                <span
                  class="icon"
                  :style="{backgroundImage:'url('+icon.bgm+')'}"
                  :class="{'ms-off':msOff}"
                ></span>背景音乐
              </a>
            </li>
            <li>
              <a href="javascript:;" @click="toggleRotate">
                <span class="icon" :style="{backgroundImage:'url('+icon.rotate+')'}"></span>自动旋转
              </a>
            </li>
            <li>
              <a href="javascript:;" @click="enterVR">
                <span class="icon" :style="{backgroundImage:'url('+icon.vr+')'}"></span>VR模式
              </a>
            </li>
            <li>
              <a href="javascript:;" @click="showTeam">
                <span class="icon" :style="{backgroundImage:'url('+icon.team+')'}"></span>技术支持
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import scrollBar from "vue-scroll-bar";

export default {
  name: "App",
  components: {
    scrollBar,
  },
  data() {
    return {
      showMore: false,
      msOff: false,
      showContent: false,
      showTeamLayer: false,
      icon: {
        scene: require("./../public/icon/scene.png"),
        info: require("./../public/icon/info.png"),
        more: require("./../public/icon/more.png"),
        rotate: require("./../public/icon/rotate.png"),
        vr: require("./../public/icon/vr.png"),
        team: require("./../public/icon/team.png"),
        teamImg: require("./../public/icon/team_img.png"),
        card: require("./../public/icon/card.png"),
        bgm: require("./../public/icon/bgm.png"),
        close: require("./../public/icon/close.png"),
      },
      scrollTrackStyle: {
        backgroundColor: "rgba(0,0,0,.2)",
      },
      scrollBarStyle: {},
      content: "",
    };
  },
  mounted() {
    window.embedpano({
      swf: "tour.swf",
      xml: "vtour/tour.xml",
      target: "pano",
      html5: "auto",
      mobilescale: 1.0,
      passQueryParameters: true,
    });
  },
  methods: {
    toggleBGN() {
      this.$root.kr().call("pausesoundtoggle('bgsnd')");
      this.msOff = !this.msOff;
      setTimeout(() => {
        this.showMore = false;
      }, 500);
    },
    loadContent(url) {
      this.$http.get(url).then((r) => {
        this.content = r.data;
        this.showMore = false;
      });
    },
    loadUrl(url) {
      this.content = `<iframe src="${url}" style="position: fixed; top: 0;left: 0;"  width="100%" height="100%" frameborder="0"></iframe>`;
      this.showMore = false;
    },
    toggleScene(flag) {
      this.$root.kr().call("toggle_groups(" + flag + ")");
      this.showMore = false;
    },
    toggleRotate() {
      this.$root.kr().call("switch('autorotate.enabled')");
      this.showMore = false;
    },
    toggleMore() {
      this.$root.kr().call("toggle_groups(false)");
      this.showMore = !this.showMore;
    },
    enterVR() {
      this.$root.kr().call("plugin[webvr].enterVR()");
      this.showMore = false;
      this.$root.ui = false;
    },
    showTeam() {
      this.showTeamLayer = true;
      this.showMore = false;
    },
    closeContent() {
      this.content = "";
      this.$root.kr().call('resumeallsounds()');
    },
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}
html,
body {
  height: 100%;
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: hidden;
}

#pano {
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
#app .fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
#app .fade-enter,
.fade-leave-to {
  opacity: 0;
}
#menu {
  position: absolute;
  bottom: 0;
  height: 70px;
  width: 100%;
  background: rgba(0, 0, 0, 0.628);
  text-align: center;
}
#menu > ul {
  width: 500px;
  display: inline-block;
}

#menu a {
  display: block;
  text-decoration: none;
  color: white;
}

#menu > ul li {
  display: inline-block;
  height: 70px;
  line-height: 70px;
  border-right: 2px solid rgba(199, 31, 31, 0.222);
  padding: 0 10px;
  width: 25%;
  box-sizing: border-box;
  position: relative;
}
@media (max-width: 600px) {
  #menu > ul {
    width: 100%;
  }
  #menu > ul li {
    padding: 0;
    font-size: 12px;
  }
}
#menu > ul li:first-child {
  border-left: 2px solid rgba(255, 0, 0, 0.222);
}
#menu > ul li:hover {
  background: rgba(255, 255, 255, 0.26);
}
#menu > ul li a {
  text-indent: 20px;
  transform: translateX(5px);
}
#menu > ul li a span {
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
}
#menu .more {
  position: absolute;
  bottom: 0;
  right: 0;
  min-width: 100%;
  background: rgba(0, 0, 0, 0.637);
  transform: translateY(2000px);
  transition: all 0.5s;
}
object {
  display: none;
}
#menu ul .more li {
  display: block;
  width: 100%;
  border: none;
  border: none;
}
#menu .more.show-more {
  opacity: 1;
  transform: translateY(-70px);
}

.icon {
  background-size: 20px;
  background-repeat: no-repeat;
  top: 25px;
}
.icon.ms-off {
  background-position-y: -20px;
}
.wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  position: fixed;
  z-index: 100;
  text-align: left;
}
.wrap-header {
  height: 50px;
  line-height: 50px;
  width: 100%;
  top: 0;
  position: absolute;
}
.wrap-body {
  overflow: hidden;
  top: 50px;
  height: calc(100% - 50px);
}
a.close {
  width: 26px;
  height: 26px;
  overflow: hidden;
  position: absolute;
  background-size: contain;
  right: 7px;
  top: 7px;
}
</style>

